module.exports = __webpack_public_path__ + "img/55.maintenance_fixed.5172b36a.svg";